import type { MarketConfig } from '../../types';

export const academyEsConfig = {
  slug: 'aca-es-incompany',
  label: 'Academy Spain',
  country: 'ES',
  language: 'es',
  siteSection: 'ACA_ES',
  cms: 'AzureSWA',
  title: 'Formación In Company para empresas | TÜV SÜD Academy España',
  description:
    'Programas de formación In Company a medida para empresas en España, diseñados por TÜV SÜD Academy con expertos del sector.',
  themeColor: '#0046ad',
  ogImage: 'https://mango-grass-0099f4103.6.azurestaticapps.net/favicon.png',
  ogImageAlt: 'TÜV SÜD Academy España In Company landing page preview image',
  twitterCard: 'summary_large_image',
  robots: 'noindex,nofollow',
} satisfies MarketConfig;
